import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ShareButton } from 'site-modules/lease-deals/components/engagement-widgets/share-button/share-button';

const EngagementPanelUI = memo(({ className = undefined, styleId, id, make, model, year }) => {
  return (
    <div className={classNames('engagement-panel d-flex justify-content-center', className)}>
      <ShareButton styleId={styleId} id={id} make={make} model={model} year={year} />
    </div>
  );
});

EngagementPanelUI.displayName = 'EngagementPanelUI';
EngagementPanelUI.propTypes = {
  styleId: PropTypes.number.isRequired,
  id: PropTypes.string.isRequired,
  make: PropTypes.string.isRequired,
  model: PropTypes.string.isRequired,
  year: PropTypes.number.isRequired,
  className: PropTypes.string,
};

export const EngagementPanel = EngagementPanelUI;
